import { Component, Inject } from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef
} from "@angular/material/bottom-sheet";
import { MapItemData, UserModel } from "../../../../model/general.model";
import { Router } from '@angular/router';
import { GO_URL, TASKS_URL } from '../../../../config/url.config';
import { userOptionLabel } from '../../../../utils/user.utils';
import { TASK_TYPE } from '../../../go/model/task.model';

@Component({
  selector: 'bottom-sheet-attributes',
  templateUrl: './bottom-sheet-attributes.component.html',
  styleUrls: ['./bottom-sheet-attributes.component.scss']
})
export class BottomSheetAttributesComponent {

  showNavigationBtn = false;

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: MapItemData,
    private sheetRef: MatBottomSheetRef<BottomSheetAttributesComponent>,
    private router: Router,
  ) {
    this.showNavigationBtn = data.type === TASK_TYPE.TOWER;
  }
  goToTask(id: number) {
    void this.router.navigate([GO_URL, TASKS_URL, id]);
    this.sheetRef.dismiss();
  }

  getUserLabel(user: UserModel): string {
    return userOptionLabel(user);
  }

  close(): void {
    this.sheetRef.dismiss();
  }

  goToGoogleMaps() {
    if (this.data.longitude && this.data.latitude) {
      const url = `https://www.google.com/maps/dir/?api=1&destination=${this.data.latitude},${this.data.longitude}`;
      window.open(url, '_blank'); // Otwiera Google Maps w nowej karcie
    }
  }
}
